export default async () => {
  const entries = document.querySelectorAll('.del-header');
  if (entries.length > 0) {
    const controller = await import(
      /* webpackChunkName: "DELHeaderNavigationController-lib" */ '@/delonghi/Controllers/DELHeaderNavigation/DELHeaderNavigationController'
    );
    controller.default();
  }
};
